export const REGEX_TELEFONNUMMER = /^(\d-?\d*)+\d$/;
export const REGEX_ZUSTAENDIGKEITEN_ZUST_SBD = /^(.*ZustSBD.*)$/;
